// extracted by mini-css-extract-plugin
export default {"badge":"RegistrationProgressDesktop_badge__pko6a","cartImg":"RegistrationProgressDesktop_cartImg__32Ncj"};